<template>
  <el-container v-title data-title="生成验证码" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>生成验证码</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="addForm" :inline="true" :model="addData" :rules="rules">
                <el-form-item label="手机号码">
                  <el-input v-model="addData.mobile" placeholder="请输入"></el-input>
                </el-form-item>
                <br>
                <el-form-item>
                  <el-button type="primary" @click="generateCaptcha">生成</el-button>
                </el-form-item>
                <br>
                <span style="margin: 35px; font-size: 50px; color: #F00">{{captchaCode}}</span>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      addData: {
        mobile: ''
      },
      captchaCode: '',
      rules: {
        type: [{ required: true, message: '请填写手机号码', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    generateCaptcha () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/generateCaptchaCodeWithoutSend',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          mobile: _this.addData.mobile
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.captchaCode = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    }
  }
})
</script>
<style>
.messageContentBox, .messageContentBox .el-form-item__content {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateCaptcha.vue